<script setup>
import { useI18n } from "vue-i18n";
import getLocale from "@/locale";
const { t, tm } = useI18n();
const locale = getLocale();

const email = "alfaplanner@pec.it"

const italianText = {
  subtitleWithEmail: `La società delegata ex art. 5, comma 3, del D.P.R. n. 430/2001 è Alfaplanner s.r.l., con sede legale in Grosseto, Via Veio n.22, Codice Fiscale, Partita IVA ed iscrizione nel Registro delle Imprese di Grosseto n. 01480420536, R.E.A n. 127909, capitale sociale Euro 10.000,00 i.v., PEC: ${email} (di seguito, il "Soggetto Delegato").`,
}

</script>
<template>
  <div class="tc-wrapper">
    <div class="tc-welcome razor-down-grey">
      <div class="tc-content">
        <h1>{{ t('termsAndConditions.mainSection.title') }}</h1>
        <p class="welcome">{{ t('termsAndConditions.mainSection.subtitle') }}</p>
        <p class="welcome" v-if="locale === 'it'">{{italianText.subtitleWithEmail}}</p>
      </div>
    </div>
    <div class="faq-wrapper">
      <div class="text-container">
        <div
            class="section"
            v-for="(section, sectionIndex) in tm('termsAndConditions.mainSection.content')"
            :key="sectionIndex"
        >
          <div class="section-header">
            <h2>{{ section.section }}</h2>
            <h2>{{ section.title }}</h2>
          </div>
          <ul>
            <li
                class="lower-alpha"
                v-for="(requirement, index) in section.requirements"
                :key="index"
            >
              <p v-html="requirement.text"></p>
              <ul v-if="requirement.dates">
                <li v-for="(date, dateIndex) in requirement.dates" :key="dateIndex">
                  <p>{{ date }}</p>
                </li>
              </ul>
              <ul v-if="requirement.contactDetails">
                <li v-for="(detail, detailIndex) in requirement.contactDetails" :key="detailIndex">
                  <p v-html="detail"></p>
                </li>
              </ul>
              <ul v-if="requirement.additionalText">
                <li class=lower-roman v-for="(additionalText, additionalTextIndex) in requirement.additionalText" :key="additionalTextIndex">
                  <p>{{ additionalText.description}}</p>
                  <ul v-if="additionalText.list">
                    <li :class="locale === 'it' ? 'lower-numeric' : 'lower-roman'" v-for="(listItem, listItemIndex) in additionalText.list" :key="listItemIndex">
                      <p>{{ listItem }}</p>
                    </li>
                  </ul>
                  <ul v-if="additionalText.listAlpha">
                    <li class="lower-alpha" v-for="(listItem, listItemIndex) in additionalText.listAlpha" :key="listItemIndex">
                      <p>{{ listItem }}</p>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tc-wrapper {
  background: #ff8000;
}

.tc-welcome{
  position: relative;
  display: block;
  margin: 0 auto;
  text-align: center;
  padding: 60px 0 262px 0;
  text-wrap: pretty;
}

.razor-down-grey {
  position: relative;
}
/* .razor-down-grey:before {
  content: "";
  position: absolute;
  right: 0;
  left: 0;
  bottom: -0.2px;
  margin: 0 auto;
  width: 100%;
  height: 9vw;
  overflow: hidden;
  clip-path: polygon(100% 0, 0% 100%, 100% 100%);
  background: #f8f5f2;
} */

.tc-content {
  max-width: 1125px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tc-content h1 {
  max-width: 850px;
}

.tc-content p {
  color: #fff;
  padding: 24px 0;
  margin: 0 auto;
  max-width: 800px;
}

.text-container {
  max-width: 1125px;
  background-color: #fff;
  color: #1a1a19;
  border-radius: 30px;
  padding: 60px 80px;
  font-family: "JETSansVF2", Arial, sans-serif;
  font-size: 16px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  margin-top: -280px;
  display: flex;
  flex-direction: column;
  text-wrap: pretty;
}

.section {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.section-header {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
  gap: 15px;
}

.section-header h2 {
  font-weight: bold;
  margin-bottom: 10px;
}

.lower-alpha{
  list-style: lower-alpha;
  padding-left: 25px;
}

.lower-roman {
  list-style: lower-roman;
  padding-left: 10px;
}

.lower-numeric {
  list-style: lower-numeric;
  padding-left: 10px;
}

.text-container ul {
  list-style-type: none;
  padding-left: 0;
}

.text-container li {
  margin: 0 0 0 30px;
}

.faq-wrapper {
  background-color: #f8f5f2;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 60px;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
}

@media (max-width: 768px) {
  .tc-content h1 {
    font-size: 26px;
    line-height: 26px;
    margin: -16px auto 34px;
    text-align: center;
  }

  .tc-content p {
    font-size: 14px;
    line-height: 24px;
    padding: 0 20px;
    text-align: center;
    max-width: 600px;
  }

  p {
    font-size: 14px;
    line-height: 24px;
    margin: 10px;
  }

  .lower-alpha{
    padding-left: 0;
  }

  .lower-roman {
    padding-left: 0;
  }

  .text-container {
    padding: 20px;
  }

  .faq-wrapper {
    padding: 50px 20px 20px;
  }
}

@media (max-width: 380px){
  .text-container {
    padding: 15px;
  }
}
</style>
